import { render, staticRenderFns } from "./GoodsTabLinks.vue?vue&type=template&id=8d7df260"
import script from "./GoodsTabLinks.vue?vue&type=script&lang=js"
export * from "./GoodsTabLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports